<router-outlet></router-outlet>
<ngx-spinner type="ball-clip-rotate" color="#ffffff" type="ball-clip-rotate">
  <p style="color: white">{{ configService.spinnerMessage }}</p>
</ngx-spinner>
